import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/spinning-mew.gif'


_pushScopeId("data-v-b7e20bcc")
const _hoisted_1 = { class: "loader" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "loader__img",
  src: _imports_0,
  alt: "mew spinning loader gif"
}, null, -1)
const _hoisted_3 = { class: "loader__subtitle" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Catching ")
const _hoisted_5 = { class: "loader__pokemon-name" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" ... ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h2", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.pokemonName), 1),
      _hoisted_6
    ])
  ]))
}